import {Component, Input, OnInit, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {LoadingBarService} from '@ngx-loading-bar/core';

@Pipe({name: 'safe'})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(url) {
    // return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-i-frame',
  templateUrl: './i-frame.component.html',
  styleUrls: ['./i-frame.component.scss']
})
export class IFrameComponent implements OnInit {

  @Input() iframeSrc?: string;
  @Input() iframeHeight?: string;
  @Input() iframeTitle?: string;

  title: string = 'Map Service';

  constructor(
    private loadingBar: LoadingBarService,
  ) {
  }

  ngOnInit() {
    this.loadingBar.useRef('start');
  }

  iframeLoaded(event: Event) {
    this.loadingBar.useRef('stop');
  }

}
